import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import BaseTableCell from 'components/molecules/TableCells/BaseTableCell/BaseTableCell';

const StyledLinkTableCell = styled(BaseTableCell)`
  > * {
    white-space: nowrap;
    width: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
  }
  
  ${ComponentStyles}
`;

StyledLinkTableCell.propTypes = {
  theme: PropTypes.object
};

export default StyledLinkTableCell;
